
import { Brain } from 'lucide-react';

export function CopilotPage() {
    return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-gray-50">
            <div className="p-8 bg-white rounded-lg shadow-sm text-center max-w-md">
                <div className="text-primary mb-4">
                    <Brain className="w-16 h-16 mx-auto stroke-[1.5px]" />
                </div>
                <h2 className="text-xl font-semibold text-gray-800 mb-2">Copilot Coming Soon</h2>
                <p className="text-gray-600 mb-4">
                    We're working on a new version of Copilot that will be integrated directly into the application.
                </p>
                <p className="text-gray-600 mb-4">
                    In the meantime, you can use the Copilot sidebar by clicking the brain icon in the sidebar.
                </p>
            </div>
        </div>
    );
}